import PropTypes from "prop-types";
import React, { Component } from "react";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import { withRouter, Link } from "react-router-dom";
import { withTranslation } from "react-i18next";

import menuConfig from "./menuConfig";

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.refDiv = React.createRef();
    this.metisMenu = null;
  }

  componentDidMount() {
    const menuEl = document.getElementById("side-menu");
    if (menuEl) {
      this.metisMenu = new MetisMenu("#side-menu");
    }
  }

  componentDidUpdate(prevProps) {
    // Chỉ re-init khi type đổi, không re-init khi pathname đổi
    if (this.props.type !== prevProps.type) {
      if (this.metisMenu?.dispose) {
        this.metisMenu.dispose();
      }
      this.metisMenu = new MetisMenu("#side-menu");
    }
  }

  componentWillUnmount() {
    if (this.metisMenu?.dispose) {
      this.metisMenu.dispose();
    }
  }

  isChildActive = childPath => {
    return this.props.location.pathname.startsWith(childPath);
  };

  isParentActive = item => {
    if (!item.children) return false;
    return item.children.some(child =>
      this.props.location.pathname.startsWith(child.path)
    );
  };

  renderChild = (child, t) => {
    const isActive = this.isChildActive(child.path);

    return (
      <li key={child.path} className={isActive ? "mm-active" : ""}>
        <Link to={child.path} className={isActive ? "active" : ""}>
          <i className={child.icon}></i>
          <span>{t(child.label)}</span>
        </Link>
      </li>
    );
  };

  renderItem = (item, t) => {
    if (item.children) {
      const isParentActive = this.isParentActive(item);

      return (
        <li key={item.title} className={isParentActive ? "mm-active" : ""}>
          <a
            href="/#"
            className={`has-arrow ${isParentActive ? "active" : ""}`}
            onClick={e => e.preventDefault()}
          >
            {item.badge && (
              <span className="badge rounded-pill bg-danger float-end">
                {t(item.badge)}
              </span>
            )}
            <i className={item.icon}></i>
            <span>{t(item.title)}</span>
          </a>

          <ul
            className={`sub-menu mx-1 ${isParentActive ? "mm-show" : ""}`}
            aria-expanded={isParentActive ? "true" : "false"}
          >
            {item.children.map(child => this.renderChild(child, t))}
          </ul>
        </li>
      );
    }

    const isActive = this.props.location.pathname.startsWith(item.path);

    return (
      <li key={item.path} className={isActive ? "mm-active" : ""}>
        <Link to={item.path} className={isActive ? "active" : ""}>
          {item.badge && (
            <span className="badge rounded-pill bg-danger float-end">
              {t(item.badge)}
            </span>
          )}
          <i className={item.icon}></i>
          <span>{t(item.label)}</span>
        </Link>
      </li>
    );
  };

  render() {
    const { t } = this.props;

    return (
      <React.Fragment>
        <SimpleBar className="h-100" ref={this.refDiv}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              <li className="menu-title">{t("Danh mục")}</li>
              {menuConfig.map(item => this.renderItem(item, t))}
            </ul>
          </div>
        </SimpleBar>
      </React.Fragment>
    );
  }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
};

export default withRouter(withTranslation()(SidebarContent));
